import type { CSSProperties } from 'react'
import type { SpacingDivProps, SpacingProps } from './Spacing.props'

const Spacing = ({ children, style, width, height, ...props }: SpacingProps & SpacingDivProps) => {
  const styles: CSSProperties = {
    height,
    width,
  }

  return (
    <div style={{ ...style, ...styles }} {...props}>
      {children}
    </div>
  )
}

export { Spacing }
